import { render } from "./ButtonRenewMandate.vue?vue&type=template&id=21818645"
import script from "./ButtonRenewMandate.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonRenewMandate.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/ButtonRenewMandate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21818645"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21818645', __exports__)) {
    api.reload('21818645', __exports__)
  }
  
  module.hot.accept("./ButtonRenewMandate.vue?vue&type=template&id=21818645", () => {
    api.rerender('21818645', render)
  })

}


export default __exports__